import { render, staticRenderFns } from "./address-adds-dialog.vue?vue&type=template&id=4c2743b4&scoped=true"
import script from "./address-adds-dialog.vue?vue&type=script&lang=js"
export * from "./address-adds-dialog.vue?vue&type=script&lang=js"
import style0 from "./address-adds-dialog.vue?vue&type=style&index=0&id=4c2743b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2743b4",
  null
  
)

export default component.exports